export default __webpack_public_path__ + "static/subheader_blue-04ee1c7b385a8db7d6fb1f85a0a79051.svg";